<app-container>
    <div class="row no-gutters w-100 auth-layout signup-basic-page">
        <aside class="col-12 col-lg-4">
            <div class="basic-sidebar-body">
                <div>
                    <ng-container
                        *ngIf="hasMultipleAccounts || hasSelectedRoleId">
                        <a (click)="redirectToDash(); $event.preventDefault()"
                            class="return-to-panel-link">
                            <svg-icon
                                src="assets/images/icon-left.svg"></svg-icon>
                            Retornar ao painel
                        </a>
                    </ng-container>

                    <img [src]="UIDefaultTheme.brand.logoHorizontal"
                        class="sidebar-logo d-none d-lg-flex">

                    <app-spacer [bottom]="16" class="d-none d-lg-block">
                    </app-spacer>
                    <app-stepper
                        *ngIf="!showLoadingSpinner && (activeSubstep !== null || activeStep > 0)"
                        [steps]="steps" [activeIndex]="activeStep"
                        [activeSubstepSlug]="activeSubstep || 'complementaryGeneral'"
                        [haveNavigation]="true"
                        (changeActiveStep)="setActiveStep($event)"
                        stepType="company">
                    </app-stepper>
                </div>
            </div>

            <div class="basic-sidebar-footer">
                <div class="basic-sidebar-footer-content">
                    <div class="row no-gutters w-100">
                        <div class="col-4 left-side">
                            <svg-icon src="assets/images/icon-info.svg"
                                placement="top" ngbTooltip="Ajuda"
                                tooltipClass="custom-tooltip"
                                *ngIf="UIDefaultTheme.brand.supportEmail"
                                (click)="toggleSupportModal()"></svg-icon>

                            <span class="basic-sidebar-footer-text"
                                [class.text-right]="UIDefaultTheme.brand.supportEmail">
                                Alguns campos são de preenchimento
                                obrigatório
                            </span>
                        </div>

                        <div class="col-8 right-side"
                            [class.inviteLabels]="label !== null && name !== ''">
                            <ng-container *ngIf="label !== null && name !== ''">
                                <div class="basic-info">
                                    <h3>{{label}}</h3>
                                    <h4>{{name}}</h4>
                                </div>
                            </ng-container>

                            <div class="button-container"
                                *ngIf="!showLoadingSpinner && (activeSubstep !== null || activeStep > 0)">
                                <ng-container
                                    *ngIf="activeSubstep !== 'complementaryGeneral'">
                                    <app-button (onClick)="runBack()"
                                        class="mr-3" [inverted]="true"
                                        [fitContent]="true">
                                        Retornar
                                    </app-button>
                                </ng-container>

                                <app-button [disabled]="getDisabled()"
                                    (onClick)="proceed()"
                                    [loading]="signupService.loading"
                                    [next]="true" [full]="currentTab
                                    === 'Anexos & comprovantes'">
                                    <div class="basic-siderbar-footer-button">
                                        <span
                                            class="basic-sidebar-footer-button-text"
                                            [style]="currentTab
                                            === 'Anexos & comprovantes' ? 'margin-right: 16px !important' : ''"
                                            [class.avaliable]="canProceed() || signupService.loading">{{currentTab
                                            === 'Anexos & comprovantes' ?
                                            'Enviar para aprovação':
                                            'Seguir'}}</span>
                                        <svg-icon [class.ml-2]="currentTab
                                        === 'Anexos & comprovantes'"
                                            [src]="getButtonIcon('next')"
                                            [class.avaliable]="canProceed() || signupService.loading">
                                        </svg-icon>
                                    </div>
                                </app-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </aside>

        <main class="col-12 col-lg-8 basic-content">
            <div class="main-header">
                <div class="credentials-container"
                    (click)="toggleUserOptions()">

                    <div class="dash-card-item-initials user-credentials">
                        <span>{{getUserInitials(userCredentials?.name ||
                            '')}}</span>
                    </div>

                    <div>
                        <h3>{{userCredentials?.name || ''}}</h3>
                        <p>{{userCredentials?.email || ''}}</p>
                    </div>
                    <div>
                        <svg-icon
                            src="assets/images/icon-carret-down.svg"></svg-icon>
                    </div>

                    <div class="credentials-options"
                        [class.active]="userOptionsOpen">
                        <div class="credentials-options-item"
                            (click)="logoff()">
                            Sair
                        </div>
                    </div>
                </div>
            </div>

            <ng-container
                *ngIf="!showLoadingSpinner && (activeSubstep !== null || activeStep > 0)">
                <ng-container *ngIf="isFund">
                    <div *ngIf="activeStep === 0">
                        <app-signup-unified-company-complementary>
                        </app-signup-unified-company-complementary>
                    </div>

                    <div *ngIf="activeStep === 1">
                        <app-signup-unified-company-powers>
                        </app-signup-unified-company-powers>
                    </div>

                    <div *ngIf="activeStep === 2">
                        <app-signup-unified-company-declarations>
                        </app-signup-unified-company-declarations>
                    </div>

                    <div *ngIf="activeStep === 3 && !isAssignorFund">
                        <app-signup-unified-company-tax>
                        </app-signup-unified-company-tax>
                    </div>

                    <div *ngIf="activeStep === 3 && isAssignorFund">
                        <app-signup-unified-company-attachments>
                        </app-signup-unified-company-attachments>
                    </div>

                    <div *ngIf="activeStep === 4 && !isAssignorFund">
                        <app-signup-unified-company-attachments>
                        </app-signup-unified-company-attachments>
                    </div>
                </ng-container>

                <ng-container *ngIf="!isFund && isShareholder">
                        <div *ngIf="activeStep === 0">
                            <app-signup-unified-company-complementary>
                            </app-signup-unified-company-complementary>
                        </div>

                        <div *ngIf="activeStep === 1">
                            <app-signup-unified-company-powers>
                            </app-signup-unified-company-powers>
                        </div>

                        <div *ngIf="activeStep === 2">
                            <app-signup-unified-company-income>
                            </app-signup-unified-company-income>
                        </div>

                        <div *ngIf="activeStep === 3">
                            <app-signup-unified-company-declarations>
                            </app-signup-unified-company-declarations>
                        </div>

                        <div *ngIf="activeStep === 4">
                            <app-signup-unified-company-analysis>
                            </app-signup-unified-company-analysis>
                        </div>

                        <div *ngIf="activeStep === 5">
                            <app-signup-unified-company-conditions>
                            </app-signup-unified-company-conditions>
                        </div>

                        <div *ngIf="activeStep === 6">
                            <app-signup-unified-company-tax>
                            </app-signup-unified-company-tax>
                        </div>

                        <div *ngIf="activeStep === 7">
                            <app-signup-unified-company-attachments>
                            </app-signup-unified-company-attachments>
                        </div>
                </ng-container>

                <ng-container *ngIf="!isFund && !isShareholder">
                    <div *ngIf="activeStep === 0">
                        <app-signup-unified-company-complementary>
                        </app-signup-unified-company-complementary>
                    </div>

                    <div *ngIf="activeStep === 1">
                        <app-signup-unified-company-powers>
                        </app-signup-unified-company-powers>
                    </div>

                    <div *ngIf="activeStep === 2">
                        <app-signup-unified-company-attachments>
                        </app-signup-unified-company-attachments>
                    </div>
                </ng-container>
            </ng-container>
        </main>
    </div>
</app-container>

<ng-container *ngIf="UIDefaultTheme.brand.supportEmail">
    <app-warning-modal [active]="showSupportModal" [hasBorder]="true"
        (onClose)="toggleSupportModal()">
        <h2>Precisa de ajuda</h2>
        <app-spacer [bottom]="8"></app-spacer>
        <p>você pode entrar em contato conosco pelos meios abaixo:</p>
        <app-spacer [bottom]="8"></app-spacer>
        <a
            [href]="'mailto:' + UIDefaultTheme.brand.supportEmail">{{UIDefaultTheme.brand.supportEmail}}</a>
    </app-warning-modal>
</ng-container>

<app-loading-spinner
    [active]="showLoadingSpinner || signupService.loading"></app-loading-spinner>